import { render, staticRenderFns } from "./DosyaninYetkiliIcraDairesineGonderilmesiTalepEvrakForm.vue?vue&type=template&id=0afd94a8"
import script from "./DosyaninYetkiliIcraDairesineGonderilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./DosyaninYetkiliIcraDairesineGonderilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports